export default {"src":"/_next/static/media/infinity_40.0908ea64.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};